import React from 'react';
import PropTypes from 'prop-types';
import {
  AddSeriesIcon,
  ArrowIcon,
  CalendarIcon,
  ChangeSeriesIcon,
  ChevronIcon,
  CloseIcon,
  DeleteIcon,
  DropDownIcon,
  DownArrowWithBackground,
  EditIcon,
  ExpandIcon,
  FeedbackIcon,
  GoalPolygon,
  GraphIcon,
  HamburgerMenu,
  NavBarGraph,
  NavSeriesComparison,
  NavDynamicTable,
  NoSalesImage,
  NoSalesDnDImage,
  PrintIcon,
  ResetIcon,
  RightArrowWithBackground,
  SeriesComparisonGraphic,
  SortingIcon,
  TrashIcon,
  ToggleIconOff,
  ToggleIconOn
} from 'components/lib/icons/SvgIcons';
import { PrimaryButton } from 'components/lib/buttons/Button';
import styles from 'styles/components/lib/buttons/iconButtons.css';

const IconBtn = ({ children, color='#888888', disabled, isDisabled, isExpanded, label, style, ...props}) =>
<button type="button"
        style={ Object.assign({}, style,
          { color: color,
            opacity: `${disabled || isDisabled ? '0.54' : '1'}`,
	          cursor: `${ disabled || isDisabled ? 'default' : 'pointer'}` }
        )}
        disabled={disabled || isDisabled}
        {...props} >
  { label && <span>{label}</span> }
  { children }
</button>

const ReverseIconBtn = ({label, children, color='#888888', style, ...props}) =>
<button type="button" style={Object.assign({}, style, {color: color})} {...props} >
  { children }
  { label && <span style={{margin: '0px 0px 0px 6px', fontSize: '14px'}}>{label}</span> }
</button>

const IconLink = ({label, children, color='#888888', style, target="_new",  ...props}) =>
<a rel="noopener" style={Object.assign({}, style, {color: color})} target={target} {...props} >
  { label && <span>{label}</span> }
  { children }
</a>

const Icon = ({children, color='#888888', style,  ...props}) =>
<div style={Object.assign({}, style, {color: color})} {...props} >
  { children }
</div>

export const AddSeriesBtn = ({...props}) =>
<ReverseIconBtn className={ styles.changeSeriesBtn } label="Add Series"  color='#3395FF' {...props}>
  <AddSeriesIcon height="18" width="17" />
</ReverseIconBtn>

export const Arrow = ({iconSize = 20, style, ...props}) =>
<Icon style={Object.assign({}, style, {textAlign: 'center'})}>
  <ArrowIcon {...props} height={iconSize} color={props.color} />
</Icon>

export const CalendarBtn = ({date, ...props}) =>
<ReverseIconBtn className={ styles.calendarBtn } label={date} {...props}>
  <CalendarIcon />
</ReverseIconBtn>

export const ChangeSeriesBtn = ({...props}) =>
<IconBtn className={ styles.changeSeriesBtn } label="Change Series"  color='#3395FF' {...props}>
  <ChangeSeriesIcon height="11" width="9" />
</IconBtn>

export const ChevronExpandBtn = ({...props}) =>
<IconBtn color='#888888' {...props}>
  <ChevronIcon direction="bottom" />
</IconBtn>

export const ChevronCollapseBtn = ({...props}) =>
<IconBtn color='#000000' {...props}>
  <ChevronIcon direction="top" />
</IconBtn>

export const CloseBtn = ({...props}) =>
<IconBtn className={ styles.changeSeriesBtn } {...props}>
  <CloseIcon height={props.height} />
</IconBtn>

export const ComparisonGraphic = ({style, ...props}) =>
<Icon className={ styles.comparisonGraphic }>
  <SeriesComparisonGraphic {...props} />
</Icon>

export const DeleteBtn = ({iconSize = 16, outerShape, ...props}) =>
<IconBtn className={ styles.deleteBtn } {...props}>
  <DeleteIcon height={iconSize} color={props.color} outerShape={outerShape} />
</IconBtn>

export const DropDownBtn = ({label, ...props}) =>
<IconBtn className={ styles.dropDownIcon }
         disabled={props.disabled}
         color="white"
         label={label}
         {...props} >
  <DropDownIcon style={{marginLeft: '5px'}} />
</IconBtn>

export const EditBtn = ({iconSize = 16, animate, ...props}) =>
<IconBtn className={ styles.deleteBtn } {...props}>
  <EditIcon height={iconSize} style={props.style} animate={animate}/>
</IconBtn>

export const ExpandBtn = ({iconSize = 16, isExpanded, ...props}) =>
<IconBtn className={ styles.deleteBtn } {...props}>
  <ExpandIcon color={props.color} height={iconSize} isExpanded={isExpanded} />
</IconBtn>

export const FeedbackBtn = ({iconSize = 16, ...props}) =>
<IconLink className={ styles.feedbackBtn } label="Feedback" {...props}>
  <FeedbackIcon height={iconSize} color={props.color} />
</IconLink>

export const Goal = ({iconSize = 20, style, ...props}) =>
<Icon style={Object.assign({}, style, {textAlign: 'center'})}>
  <GoalPolygon {...props} height={iconSize} color={props.color} />
</Icon>

export const Graph = ({iconSize = 20, style, ...props}) =>
<Icon style={Object.assign({}, style, {textAlign: 'center', padding: '10px 0px'})}>
  <GraphIcon {...props} height={iconSize} color={props.color} />
</Icon>

export const HamburgerButton = ({iconSize = 16, ...props}) =>
<IconBtn {...props}>
  <HamburgerMenu />
</IconBtn>

export const NavMain = ({iconSize = 16, ...props}) =>
<IconBtn {...props}>
  <NavBarGraph color={props.color}/>
</IconBtn>

export const NavComparison = ({iconSize = 16, ...props}) =>
<IconBtn {...props}>
  <NavSeriesComparison color={props.color}/>
</IconBtn>

export const NavTable = ({iconSize = 16, ...props}) =>
<IconBtn {...props}>
  <NavDynamicTable color={props.color}/>
</IconBtn>

export const NoSales = ({style, ...props}) =>
<Icon className={ styles.noSales }>
  <NoSalesImage {...props} />
</Icon>

export const NoData = ({style, ...props}) =>
  <Icon className={ styles.noData }>
    <NoSalesDnDImage {...props} />
  </Icon>

export const PrintBtn = ({iconSize = 16, ...props}) =>
<IconBtn className={ styles.printBtn } label="Print" {...props}>
  <PrintIcon height={iconSize} color={props.color} />
</IconBtn>

export const ResetBtn = ({iconSize = 16, ...props}) =>
<IconBtn className={ styles.resetBtn } {...props}>
  <ResetIcon height={iconSize} color={props.color} />
</IconBtn>

export const RefreshColorsBtn = ({iconSize = 16, ...props}) =>
  <ReverseIconBtn className={ styles.refreshColorsBtn } label="Refresh Colors"  color='#666666' {...props}>
    <ResetIcon height={iconSize} color={props.color} />
  </ReverseIconBtn>

export const StartComparisonBtn = ({iconSize = 16, ...props}) =>
<PrimaryButton label="Start Comparison" {...props}>
  <RightArrowWithBackground style={{marginLeft: '10px'}}/>
</PrimaryButton>

export const SortingBtn = ({...props}) =>
<IconBtn {...props}>
  <SortingIcon />
</IconBtn>

export const Toggle = ({iconSize = 16, isToggle, ...props}) =>
<IconLink className={ styles.toggle } {...props}>
  { isToggle ?
    (
      <ToggleIconOn height={iconSize} />
    ) : (
      <ToggleIconOff height={iconSize} />
    )
  }
</IconLink>

export const UngroupBtn = ({...props}) =>
<IconBtn {...props}>
  <TrashIcon />
</IconBtn>

IconBtn.PropTypes = {
  color: PropTypes.string,
  iconSize: PropTypes.number,
  label: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
  onClick: PropTypes.func.isRequired,
  style: PropTypes.object,
  // tooltip: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/scripts/components/lib/buttons/IconButtons.js